<div class="dialog-wrapper">
  <div class="dialog-header">
    <div class="title">
      {{msg?.title}}
    </div>
    <div class="flex1"></div>
    <a mat-dialog-close class="close-dialog" (click)="onClose('no')">
      <i class="material-icons">&#xE14C;</i>
    </a>
  </div>
  <div class="dialog-content">
    <div class="form-content">
      <div class="aside-warning info">
        <i class="material-icons">warning</i>
        <span>{{msg?.memo}}</span>
      </div>
      <p>Are you sure, you want to continue?</p>
    </div>
  </div>
  <div class="dialog-footer">
    <div class="flex1"></div>
    <a mat-button mat-dialog-close class="cancel-btn">Cancel</a>
    <button class="submit-btn" mat-button type="submit" cdkFocusInitial (click)="dialogRef.close('yes')">OK</button>
  </div>
</div>